import { render, staticRenderFns } from "./KubeYamlEditor.vue?vue&type=template&id=9b01449a&scoped=true&"
import script from "./KubeYamlEditor.vue?vue&type=script&lang=js&"
export * from "./KubeYamlEditor.vue?vue&type=script&lang=js&"
import style0 from "./KubeYamlEditor.vue?vue&type=style&index=0&id=9b01449a&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b01449a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VCheckbox,VSwitch})
